import { fExecuteAPI } from "../../Server/Apis";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";

import moment from "moment";
import { vRdxUserInfo, CyclecountRo, KernCAConfig } from "../../Redux/roStore";
import {
  Set_SliceCyclecount_HeadObj,
  Set_SliceCyclecount_HeadObject_A_DocStat,
} from "./SliceCyclecount";
import {
  CycleCount_approve_var_API,
  CycleCount_BRow_API,
  CycleCount_save_API,
} from "../../Server/ApiV2";
import { esES } from "@mui/x-date-pickers";
// item
export const GCToggleSearch_ItemName_Columns = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "ItmCd", headerName: "ItmCd", width: 90 },
  { field: "Name1", headerName: "Name1", width: 450 },
  { field: "NameFL", headerName: "NameFL", width: 90 },
  { field: "MainGrpName", headerName: "MainGrpName", width: 90 },
  { field: "SuppRefNo1", headerName: "SuppRefNo1", width: 90 },
  { field: "Model", headerName: "Model", width: 90 },
  { field: "BaseUnitName", headerName: "BaseUnitName", width: 90 },
  { field: "BarCode", headerName: "BarCode", width: 90 },
];
export const GCToggleSearch_ItemName_Select_Arr = [
  "Any",
  "Code",
  "Barcode",
  "Name",
  "RefNo",
  "NameFL",
];

//customer
export const xGC_Toggle_Head_BinName_GridColumns = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "UId", headerName: "Code", width: 90 },
  { field: "Name1", headerName: "Name1", width: 450 },
  { field: "BinAttr1", headerName: "BinAttr1", width: 450 },
  // { field: "Name1", headerName: "Name1", width: 220 },
];
export const xGC_Toggle_Head_BinName_DropDown_Arr = ["Any", "Code", "Name"];

export let Summary_Grid_Columns = [
  {
    field: "A_SheetId",
    headerName: "Sheet No",
    width: 150,
  },
  {
    field: "LocName",
    headerName: "Location",
    width: 200,
  },
  {
    field: "A_RefNo",
    headerName: "RefNo",
    width: 100,
  },
  {
    field: "A_Date",
    headerName: "Date",
    width: 100,
    valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
  },
  {
    field: "A_POTyp",
    headerName: "POType",
    width: 100,
  },
  {
    field: "A_PONo",
    headerName: "PONo",
    width: 100,
  },
  {
    field: "POTypeName",
    headerName: "POTypeName",
    width: 150,
  },
  {
    field: "A_UserCd",
    headerName: "PDT UserCd",
    width: 300,
    hide: true,
  },
  {
    field: "Username",
    headerName: "Username",
    width: 100,
  },
  {
    field: "A_Status",
    headerName: "Status",
    width: 100,
  },
];
export const Detail_Grid_columns = [
  {
    field: "B_SheetId",
    headerName: "Sheet No",
    width: 150,
    hide: true,
  },
  {
    field: "B_SrNo",
    headerName: "Sr No",
    width: 50,
  },
  {
    field: "B_CardID",
    headerName: "CardID",
    width: 150,
  },
  {
    field: "B_ItmCd",
    headerName: "Item Code",
    width: 90,
    hide: true,
  },
  {
    field: "ItmName",
    headerName: "Item Name",
    width: 320,
  },
  {
    field: "B_BinCd",
    headerName: "BinCd",
    width: 50,
    hide: true,
  },
  {
    field: "BinName",
    headerName: "BinName",
    width: 300,
  },

  {
    field: "B_Qty",
    headerName: "Qty",
    width: 50,
  },
  {
    field: "B_Unit",
    headerName: "Unit",
    width: 100,
  },
  {
    field: "B_BaseQty",
    headerName: "Base Qty",
    width: 100,
  },
];
export const ErrorMsgDetail = {
  B_Srno: "", // int
  B_CardId: "",
  B_Itmcd: "",
  B_ItmName: "",
  B_Qty: "", //Decimal
  B_Unit: "",
  B_UnitName: "",
  B_PackQty: "", //Decimal
  B_Packing: "", //Decimal
  B_BaseQty: "", //Decimal
};

export const sTrnTyp = "WMPOIPT01";

const GetItemFullSearchArr = async (xItemName, xLoc) => {
  let vItemFullSearchDataObj = {
    anyData: xItemName,
    transType: "F",
    report: "Y",
    loc: xLoc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemFullSearchDataObj);

  const vItemSearchFull = await fExecuteAPI("SEARCHEXACTITEM_GETROW", FinalObj);
  if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
    if (vItemSearchFull.ResultSet.length > 0) {
      return vItemSearchFull?.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      vItemSearchFull?.Type?.response?.data?.message
        ? vItemSearchFull?.Type?.response?.data?.message
        : "Error in vItemSearchFullArr"
    );
    return [];
  }
};

const GetUnitArr = async (xItemCode, setUnit) => {
  let itemUnitobj = {
    itemCd: xItemCode,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(itemUnitobj);

  const UnitInfo = await fExecuteAPI("GETITEMUNITS_GETROW", FinalObj);
  if (UnitInfo?.Type?.toUpperCase() === "SUCCESS") {
    if (UnitInfo.ResultSet.length > 0) {
      setUnit(UnitInfo.ResultSet);
      return UnitInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      UnitInfo.Type.response.data.message
        ? UnitInfo.Type.response.data.message
        : "Error in UnitArr"
    );
    return [];
  }
};

const fItemCodeDependency = async (
  vItemSearchFull,
  setBufferObj,
  setUnit,
  defUnitValue = ""
) => {
  if (vItemSearchFull.length > 0) {
    setBufferObj((obj) => ({
      ...obj,
      B_Itmcd: vItemSearchFull[0].ItmCd,
      B_ItmName: vItemSearchFull[0].Name2,
      B_Barcode: vItemSearchFull[0].BarCode,
      RefNo: vItemSearchFull[0].SuppRefNo1,
    }));
    let currentUnitArr = await GetUnitArr(vItemSearchFull[0].ItmCd, setUnit);

    if (currentUnitArr.length > 0) {
      let vItemUnitSet = currentUnitArr.find((obj) => {
        return obj.Unit === defUnitValue;
      });
      if (!!vItemUnitSet) {
        setBufferObj((obj) => ({
          ...obj,
          B_Unit: vItemUnitSet.Unit,
          B_UnitName: vItemUnitSet.Name1,
          B_PackQty: vItemUnitSet.PackQty,
          B_Packing: vItemUnitSet.PackDesc,
        }));
      } else {
        setBufferObj((obj) => ({
          ...obj,
          B_Unit: currentUnitArr[0].Unit,
          B_UnitName: currentUnitArr[0].Name1,
          B_PackQty: currentUnitArr[0].PackQty,
          B_Packing: currentUnitArr[0].PackDesc,
        }));
      }
    }
    setTimeout(() => {
      document.getElementsByName("B_Qty")[0]?.focus(); //B_Qty
    }, 100);
    // document.getElementsByName("GC_Toggle_Head_BinName_Name")[0]?.focus();
  } else {
    fAlertToast("FAILED", "Error in Exact Search");
  }
};

const GetSearchItem = async (xData, xType, xA_Loc, setSearchGridData) => {
  let vSeatchVendor = {
    Data: xData,
    Type: xType,
    Loc: xA_Loc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSeatchVendor);
  const vItemSearch = await fExecuteAPI("SEARCHITEM001_GETROW", FinalObj);
  if (vItemSearch?.Type?.toUpperCase() === "SUCCESS") {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setSearchGridData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.response.data.message
        ? vItemSearch.response.data.message
        : "Error in SearchItem"
    );
  }
};
const fValidationHead_Client = (vRdxHead) => {
  let iRes = true;
  // let xObjHasNullOrUndefinevale =
  //   fCheck_Value_Null_Or_Undefined_ShowAlert(vRdxHead);
  // fAlertToast("WARNING", xObjHasNullOrUndefinevale);
  if (
    vRdxHead.SheetNo === "" ||
    vRdxHead.SheetNo === null ||
    vRdxHead.SheetNo === undefined
  ) {
    fAlertToast("FAILED", "Sheet Number should not be empty");
    iRes = false;
    return iRes;
  }

  if (
    vRdxHead.Loc === "" ||
    vRdxHead.Loc === null ||
    vRdxHead.Loc === undefined
  ) {
    fAlertToast("FAILED", "Location should not be empty");
    iRes = false;
    return iRes;
  }

  // default format so no need to check format
  if (
    vRdxHead.Date === "" ||
    vRdxHead.Date === null ||
    vRdxHead.Date === undefined
  ) {
    fAlertToast("FAILED", "Date should not be empty");
    iRes = false;
    return iRes;
  }

  if (
    vRdxHead.BinCd === "" ||
    vRdxHead.BinCd === null ||
    vRdxHead.BinCd === undefined
  ) {
    fAlertToast("FAILED", "Bin Code should not be empty");
    iRes = false;
    return iRes;
  }

  return iRes;
};

const fValidationDetail_Client = (sBufferObj, setErrorMsgDetail) => {
  let iRes = true;
  if (sBufferObj.B_Srno === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Srno: "Serial number should not be empty",
    }));
    iRes = false;
  }

  if (
    sBufferObj.B_CardId === "" ||
    sBufferObj.B_CardId === null ||
    sBufferObj.B_CardId === undefined
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_CardId: "CardId should not be empty",
    }));
    iRes = false;
  }

  if (
    sBufferObj.B_Itmcd === "" ||
    sBufferObj.B_Itmcd === null ||
    sBufferObj.B_Itmcd === undefined
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Itmcd: "Item code should not be empty",
    }));
    iRes = false;
  }

  if (sBufferObj.B_ItmName === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_ItmName: "Item name should not be empty",
    }));
    iRes = false;
  }

  if (
    sBufferObj.B_Qty === "" ||
    Number(sBufferObj.B_Qty) <= 0 ||
    (sBufferObj.B_Qty === null) | (sBufferObj.B_Qty === undefined)
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Qty: "Qty should not be zero",
    }));
    iRes = false;
  }

  if (sBufferObj.B_Unit === "") {
    setErrorMsgDetail((obj) => ({ ...obj, B_Unit: "Select unit" }));
    iRes = false;
  } else if (sBufferObj.B_PackQty === "" || Number(sBufferObj.B_PackQty) <= 0) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Unit: "Pack quantity should not be zero",
    }));
    iRes = false;
  }

  return iRes;
};

export const MultiCardFlag = () => {
  const { DBKernObj } = KernCAConfig();
  if (DBKernObj?.MULT_CARD_ID?.Val === "Y") return true;
  else return false;
};
//API SaveSIHead
const fSaveHead = async (fNewDetail, sBufferObj, dispatch) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const { HeadObj } = CyclecountRo(); //xSave False means Post
  let vSaveSIHeadObj = {
    v_A_SheetId: HeadObj.SheetNo,
    v_A_Loc: HeadObj.Loc,
    v_A_Date: moment(HeadObj.Date).format("YYYY-MM-DD"),
    v_A_RefNo: HeadObj.ReferenceNo,
    v_A_UserCd: vRdxUserInfoObj.UserID,
    v_B_SrNo: sBufferObj.B_Srno,
    v_B_CardID: sBufferObj.B_CardId,
    v_B_BinCd: HeadObj.BinCd,
    v_B_ItmCd: sBufferObj.B_Itmcd.trim(),
    v_B_Qty: sBufferObj.B_Qty,
    v_B_Unit: sBufferObj.B_Unit,
    v_BinName: HeadObj.BinName,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIHeadObj);
  const Resp = await CycleCount_save_API(FinalObj);

  if (Resp?.status === 200) {
    if (Resp?.data?.ResultSet) {
      dispatch(
        Set_SliceCyclecount_HeadObj({
          ...HeadObj,
          SheetNo: Resp?.data?.ResultSet?.SheetID,
        })
      );
      fNewDetail();
      fAlertToast("SUCCESS", "Successfully Saved");
    }
  }
};

const fApproveHead_Server = async (dispatch, isposting = "N") => {
  const { HeadObj } = CyclecountRo();
  const vRdxUserInfoObj = vRdxUserInfo();
  let vApproveObj = {
    v_SheetID: HeadObj.SheetNo,
    v_UserId: vRdxUserInfoObj.UserID,
    v_IP: vRdxUserInfoObj.IP,
    v_isPost: isposting,
  };

  let FinalObj = fcheck_null_undefine_replace_empty(vApproveObj);
  const Resp = await CycleCount_approve_var_API(FinalObj);
  if (Resp?.status === 200) {
    if (isposting == "Y") {
      dispatch(
        Set_SliceCyclecount_HeadObject_A_DocStat({
          A_DocStat: "POST",
        })
      );
      fAlertToast("SUCCESS", "Successfully Approved");
    } else if (isposting == "N") {
      fAlertToast("SUCCESS", "Successfully Generated Variance");
    }
    // if (vApprove?.Type?.toUpperCase() === "SUCCESS") {
    //   dispatch(
    //     Set_SliceCyclecount_HeadObject_A_DocStat({
    //       A_DocStat: "POST",
    //     })
    //   );
    //   fAlertToast("SUCCESS", "Successfully Approved");
    // }
  }
};

const GetSIDetail = async () => {
  const { HeadObj } = CyclecountRo();
  let iSIDetailObj = {
    v_B_SheetId: HeadObj.SheetNo,
  };
  let FinalObj = await CycleCount_BRow_API(iSIDetailObj);

  // const iSIDetailResult = await fExecuteAPI(FinalObj);
  if (FinalObj?.data?.length > 0 && FinalObj.status == 200) {
    return FinalObj?.data;
  } else {
    return [];
  }
};
const fLoad_Grid = async (setDetailGridData) => {
  const iSIDetail = await GetSIDetail();
  if (iSIDetail?.length > 0) {
    setDetailGridData(iSIDetail);
  } else {
    setDetailGridData([]);
  }
};

const GetPoTypeArr = async (setPoTypeArr) => {
  const UnitInfo = await fExecuteAPI("WMPOIPT01_PoType_GETROW");
  if (UnitInfo?.Type?.toUpperCase() === "SUCCESS") {
    if (UnitInfo.ResultSet.length > 0) {
      setPoTypeArr(UnitInfo.ResultSet);
    } else {
      setPoTypeArr([]);
    }
  } else {
    fAlertToast(
      "FAILED",
      UnitInfo.Type.response.data.message
        ? UnitInfo.Type.response.data.message
        : "Error in UnitArr"
    );
  }
};
export {
  GetItemFullSearchArr,
  GetUnitArr,
  GetPoTypeArr,
  fItemCodeDependency,
  GetSearchItem,
  fValidationDetail_Client,
  fValidationHead_Client,
  fLoad_Grid,
  fSaveHead,
  fApproveHead_Server,
};
